/* ==========================================================================
   Thunala - va loi duong ke accordion de len chu (footer + trang san pham)

   Trieu chung: mo accordion o footer tren dien thoai, duong ke ngang cua muc
   do nam DE LEN dong link cuoi cung.

   Nguyen nhan: `AccordionCustom.transition()` (global.js) mo accordion bang
   cach animate CHIEU CAO CUNG tinh bang px:

       height: [ `${summary.clientHeight}px`,
                 `${summary.clientHeight + content.scrollHeight}px` ]

   Con so do do MOT LAN, ngay luc bam. Sau do Motion (WAAPI) giu nguyen gia tri
   cuoi tren the. Nen bat ky thu gi lam noi dung cao them SAU thoi diem do -
   font web tai xong, anh trong menu, xoay ngang man hinh, hay chinh cai
   `padding-block-end` ma `.menu--heading-dividers .details-content` chi them o
   duoi 749px - deu khien noi dung cao hon cai chieu cao da chot. Phan thua tran
   ra ngoai, con `border-block-end` cua `<details>` van ve dung o day cua chieu
   cao cu -> thanh ra vach ngang nam giua chu.

   Cach va: sau khi animation mo xong thi tra `height: auto`. Luc do chieu cao
   do trinh duyet tinh lai lien tuc theo noi dung that, khong con con so chot
   cung nao nua. Dong lai van chay binh thuong vi luc do JS doc
   `details.clientHeight` (gia tri that dang hien) chu khong doc style da dat.

   ⚠️ Patch PROTOTYPE tu file rieng, khong sua global.js:
   - global.js la file goc cua Ella, update theme se ghi de
   - va CSS thuong KHONG the ghi de duoc: Motion dat gia tri qua Web Animations
     API, thang moi khai bao CSS thong thuong (xem rule css-and-frontend)
   ========================================================================== */

(() => {
  const apply = () => {
    const AccordionCustom = customElements.get('accordion-custom');
    if (!AccordionCustom || AccordionCustom.prototype.__etsyHeightFix) return true;

    const original = AccordionCustom.prototype.transition;
    if (typeof original !== 'function') return true;

    AccordionCustom.prototype.transition = async function (value) {
      await original.call(this, value);

      // Chi tra ve auto khi MO. Luc dong, chieu cao phai giu 0 de accordion
      // that su thu lai.
      if (!value) return;

      try {
        this.details.style.height = 'auto';
        this.contentElement.style.height = 'auto';
      } catch (error) {
        // `details` / `contentElement` cua Ella la getter co the nem loi neu
        // cau truc DOM khong nhu mong doi. Nuot loi o day - accordion van chay
        // dung nhu truoc khi co ban va, chi la khong duoc tra ve auto.
      }
    };

    AccordionCustom.prototype.__etsyHeightFix = true;
    return true;
  };

  // File nay `defer` nen thuong chay sau global.js, nhung khong dam bao thu tu
  // tuyet doi - neu component chua dinh nghia thi doi.
  if (!apply()) {
    customElements.whenDefined('accordion-custom').then(apply);
  }
})();
